module.exports = __webpack_public_path__ + "static/img/broadtreeCode.9c6a48a6.png";